import { handleResponse, handleError, getBaseUrl } from "./apiUtils";

const baseUrl = getBaseUrl(); //"https://localhost:44354/api/";

export function getDatiAcconto(codScuola, codice) {
  return fetch(`${baseUrl}scuole/${codScuola}/acconto/${codice}`)
    .then(handleResponse)
    .catch(handleError);
}
